var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.077L17.077 6l.923.923L12.923 12 18 17.077l-.923.923L12 12.923 6.923 18 6 17.077 11.077 12 6 6.923 6.923 6 12 11.077z",
    id: "CloseIcon_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#CloseIcon_svg__a",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3C!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com --%3E %3Ctitle%3Ex%3C/title%3E %3Cdesc%3ECreated with Sketch.%3C/desc%3E %3Cdefs%3E %3Cpath d='M12,11.0769231 L17.0769231,6 L18,6.92307692 L12.9230769,12 L18,17.0769231 L17.0769231,18 L12,12.9230769 L6.92307692,18 L6,17.0769231 L11.0769231,12 L6,6.92307692 L6.92307692,6 L12,11.0769231 Z' id='path-1'%3E%3C/path%3E %3C/defs%3E %3Cg id='x' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Icons-/-Close-/-L'%3E %3Cmask id='mask-2' fill='white'%3E %3Cuse xlink:href='%23path-1'%3E%3C/use%3E %3C/mask%3E %3Cuse id='Mask' fill='%23000000' fill-rule='evenodd' xlink:href='%23path-1'%3E%3C/use%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgCloseIcon as ReactComponent };